import React from 'react';

type Status = 'online' | 'offline' | 'thinking' | 'busy';

interface StatusDotProps {
  status: Status;
  size?: number;
}

const colors: Record<Status, string> = {
  online: '#10B981',
  offline: '#9CA3AF',
  thinking: '#F59E0B',
  busy: '#EF4444',
};

export const StatusDot: React.FC<StatusDotProps> = ({ status, size = 8 }) => (
  <div
    style={{
      width: size,
      height: size,
      borderRadius: '50%',
      background: colors[status],
      flexShrink: 0,
      animation: status === 'thinking' ? 'pulse 1s infinite' : 'none',
    }}
  />
);
